<template lang="pug">
  .b-spec-delivery-editor(data-testid="delivery-editor")
    ._types
      button._type(
        type="button"
        data-testid="delivery-in-stock"
        :class="{ active: type === 'in_stock' }"
        @click="type = 'in_stock'"
        ) В наличии
      button._type(
        type="button"
        data-testid="delivery-on-order"
        :class="{ active: type === 'on_order' }"
        @click="type = 'on_order'"
        ) Под заказ
    ._row(v-if="type === 'in_stock'")
      select._select(data-testid="delivery-stock" v-model="stock")
        option(
          v-for="(label, code) in STOCK_OPTIONS"
          :key="code"
          :value="code"
          data-testid="delivery-stock-option"
          ) {{ label }}
    ._row(v-else)
      select._select(data-testid="delivery-order-mode" v-model="orderMode")
        option(
          v-for="(label, code) in ORDER_MODES"
          :key="code"
          :value="code"
          data-testid="delivery-order-mode-option"
          ) {{ label }}
      input._value(
        data-testid="delivery-order-value"
        :type="orderMode === 'date' ? 'date' : 'text'"
        :placeholder="valuePlaceholder"
        v-model="orderValue"
        )
    ._buttons
      Btn(blue sm data-testid="delivery-save" @click="save") Сохранить
      Btn(grey sm @click="$emit('close')") Отмена
</template>

<script>
import { STOCK_OPTIONS, ORDER_MODES } from '@/utils/spec';

/**
 * Всплывающий редактор структуры «срок поставки / наличие» (ТЗ 2.4, 6.2). Тот же редактор
 * используется в форме отклика поставщика (ТЗ 6.5, этап 8), поэтому он ничего не знает о
 * позиции: получает значение и отдаёт новое.
 *
 * Списки — нативные select: сценарии выбирают вариант по подписи, а каждому варианту нужна
 * своя тестовая метка (ТЗ 12.8). Сгенерировано Claude.
 */
export default {
  name: 'SpecDeliveryEditor',
  props: {
    value: Object,
  },
  data() {
    const term = this.value ?? {};
    return {
      STOCK_OPTIONS,
      ORDER_MODES,
      type: term.type ?? 'in_stock',
      stock: term.stock ?? 'in_stock',
      orderMode: term.orderMode ?? 'days',
      orderValue: term.orderValue ?? '',
    };
  },
  computed: {
    valuePlaceholder() {
      switch (this.orderMode) {
        case 'days': return 'дней';
        case 'weeks': return 'недель';
        case 'date': return 'дата';
        default: return 'например, 6–8 недель';
      }
    },
  },
  methods: {
    save() {
      const term = this.type === 'in_stock'
        ? { type: 'in_stock', stock: this.stock }
        : { type: 'on_order', orderMode: this.orderMode, orderValue: String(this.orderValue ?? '').trim() };

      this.$emit('save', term);
    },
  },
};
</script>

<style scoped lang="scss">
.spec-delivery-editor {
  position: absolute;
  z-index: 50;
  top: 100%;
  left: 0;
  min-width: 260px;
  padding: 12px;
  border-radius: 8px;
  background: var(--color-white);
  box-shadow: 0 2px 30px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;

  &__types {
    display: flex;
    gap: 6px;
  }

  &__type {
    flex-grow: 1;
    padding: 6px 8px;
    border: 1px solid var(--color-super-light);
    border-radius: 6px;
    background: var(--color-white);
    font: inherit;
    font-size: 12px;
    cursor: pointer;

    &.active {
      border-color: var(--color-accent);
      color: var(--color-accent);
    }
  }

  &__row {
    display: flex;
    gap: 6px;
  }

  &__select,
  &__value {
    flex-grow: 1;
    min-width: 0;
    box-sizing: border-box;
    padding: 5px 6px;
    border: 1px solid var(--color-super-light);
    border-radius: 6px;
    font: inherit;
    font-size: 12px;
  }

  &__buttons {
    display: flex;
    gap: 8px;
  }
}
</style>
